/** Converts "YYYY-MM-DD HH:MM:SS" to "DD-MM-YYYY" */
export function renderDate(input: string | undefined): string | undefined {
  if (typeof input === 'undefined') return undefined;
  let parts = input.split(' ');
  let dateParts = parts[0].split('-');
  return dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0];
}

/** Shallow equality check for two plain objects */
export function checkIfTwoJsonObjectsAreEqual(
  obj1: Record<string, unknown>,
  obj2: Record<string, unknown>,
): boolean | undefined {
  if (typeof obj1 === 'undefined') return undefined;
  let flag = true;

  if (Object.keys(obj1).length === Object.keys(obj2).length) {
    for (const key in obj1) {
      if (obj1[key] === obj2[key]) {
        continue;
      } else {
        flag = false;
        break;
      }
    }
  } else {
    flag = false;
  }

  return flag;
}

/** Recursive equality check for two arrays, supporting nested objects/arrays */
export function checkIfTwoJsonArraysAreEqual(
  arr1: unknown[],
  arr2: unknown[],
): boolean | undefined {
  if (!arr1.length) return undefined;
  let flag = true;

  if (arr1.length === arr2.length) {
    for (let i = 0; i < arr1.length; i++) {
      if (typeof arr1[i] === 'object' && typeof arr2[i] === 'object') {
        if (Array.isArray(arr1[i])) {
          if (Array.isArray(arr2[i])) {
            flag = checkIfTwoJsonArraysAreEqual(arr1[i] as unknown[], arr2[i] as unknown[]) ?? false;
          } else {
            flag = false;
          }
        } else {
          flag = checkIfTwoJsonObjectsAreEqual(
            arr1[i] as Record<string, unknown>,
            arr2[i] as Record<string, unknown>,
          ) ?? false;
        }
      } else {
        if (arr1[i] === arr2[i]) {
          continue;
        } else {
          flag = false;
        }
      }
      if (!flag) break;
    }
  } else {
    flag = false;
  }

  return flag;
}

/**
 * Returns hours elapsed since the given UTC timestamp string.
 * Returns 10000 for invalid/missing input (treats as "window expired").
 */
export function calculate24Plus1RuleForCustomer(input: string | null | undefined): number {
  if (!input || input === 'None') return 10000;

  try {
    const isoUTC = input.replace(' ', 'T').replace(/(\.\d{3})\d*/, '$1') + 'Z';
    const utcDate = new Date(isoUTC);
    if (isNaN(utcDate.getTime())) throw new Error('Invalid date');

    const now = new Date();
    const diffInMs = now.getTime() - utcDate.getTime();
    return diffInMs / (1000 * 60 * 60);
  } catch (err) {
    console.error('Failed to parse date:', err);
    return 10000;
  }
}
